<template>
  <VDialog
    :open="isOpen"
    headline="Select Custom Field"
    modal
    @close="handleCancel"
    :style="{ '--dialog-min-inline-size': '600px', '--dialog-max-inline-size': '900px', '--dialog-max-block-size': '650px' }"
  >
    <template #body>
      <div class="custom-field-picker-wrapper">
        <custom-field-picker
          v-model="selected"
          :can-add-new="canAddNew"
          :closeOnClickOutside="false"
          :openDropdownDefault="true"
          :light-background="lightBackground"
          @change="onChange"
          ref="pickerRef"
        />
      </div>
    </template>
  </VDialog>
</template>

<script setup>
import { ref } from 'vue';
import CustomFieldPicker from './CustomDataFieldPicker.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true
  },
  canAddNew: {
    type: Boolean,
    default: false
  },
  formattedOutput: {
    type: Boolean,
    default: true
  },
  lightBackground: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:isOpen', 'selected']);

const selected = ref('');
const pickerRef = ref(null);

const onChange = () => {
  emit('selected', props.formattedOutput ? `<custom_field_${selected.value}>` : `custom_field_${selected.value}`);
  emit('update:isOpen', false);
};

const handleCancel = () => {
  emit('update:isOpen', false);
};
</script>

<style scoped>
.custom-field-picker-wrapper {
  position: relative;
  width: 100%;
  min-height: 400px;
  overflow-y: auto;
}
::v-deep(.dropdown-wrapper) {
  position: relative !important;
}
::v-deep(.dropdown-wrapper .list) {
  max-height: 100% !important;
  height: 100% !important;
}
::v-deep(.title-wrapper) {
  display: none !important;
}
</style>
